<template>
  <div class="embed-responsive embed-responsive-16by9">
    <div class="embed-responsive-item wrapper d-flex justify-content-center align-items-center">
      <div class="container-previous-next">
        <p v-if="isCountdownVisible" class="countdown-label">
          Próxima aula: <span class="font-weight-bold">{{ time }} segundos</span>
        </p>		

        <p class="up-next-label">
          {{ upNextName }}
        </p>

        <img class="img-fluid img-next" :src="showPreviousOrNextThumb" alt="" />       

        <button
          v-if="showBtnPrevious"
          @click="changeCourseModuleClassVideo(previousCourseClass)"
          class="btn-previous btn-action"
        >
          <ArrowSVG class="direction--left"/>
        </button>

        <button
          v-if="showBtnNext"
          @click="changeCourseModuleClassVideo(nextCourseClass)"
          class="btn-next btn-action"
        >
          <ArrowSVG/>
        </button>

        <p class="cancel" @click="ended">cancelar</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import ArrowSVG from "@/components/svg/ArrowSVG"

export default {
  components: {
    ArrowSVG
  },

  data: () => ({
    time: 10,
    nextClassThumb: {},
    showBtnPrevious: true,
    showBtnNext: true,
    previousCourseClass: '',
    nextCourseClass: '',   
    interval: null
  }),

  mounted() {
    this.countdown();
    this.getPreviousNextVideo();
  },

  beforeDestroy() {
    clearInterval(this.interval)
  },

  computed: {
    ...mapGetters('course', [
      'course',
      'courseModuleClass',
      'courseModuleTabActive',
      'courseClasses',
      'hasCourseAccess'
    ]),

    showPreviousOrNextThumb(){
      return this.nextCourseClass ? this.nextCourseClass.thumb : this.previousCourseClass.thumb
    },

    upNextName () {
      return this.nextCourseClass ? this.nextCourseClass.name : this.previousCourseClass.name
    },

    isCountdownVisible () {
      return this.nextCourseClass
    }
  },

  methods: {
    ...mapMutations('course', ['setCourseModuleClass', 'setCourseModuleTabActive']),

    countdown() {
      this.interval = setInterval(() => {
        if (this.time > 0) {
          this.time -= 1;
        }
        
        if (this.time <= 0) { 
          this.changeCourseModuleClassVideo(this.nextCourseClass)  
        }
      }, 1000);
    },

    getPreviousNextVideo() {
      const classIndex = this.courseClasses.findIndex(item => item.id == this.courseModuleClass.id)

      const previousResult = classIndex - 1;

      const nextResult = classIndex + 1;

      const previousClassObject = this.courseClasses[previousResult] 
      const nextClassObject = this.courseClasses[nextResult]

      if(previousClassObject == undefined) {
        this.showBtnPrevious = false 
      }

      if(nextClassObject == undefined) {
        this.showBtnNext =  !this.showBtnNext      
      }	 

      this.previousCourseClass = previousClassObject || ''
      this.nextCourseClass = nextClassObject || ''
    },

    changeCourseModuleClassVideo (courseClass) {    
      if(!courseClass) {   
        return null
      }

      if (!courseClass.is_released) {		 	
        return null
      }

      this.setCourseModuleClass(courseClass)

      if (this.courseModuleTabActive != courseClass.course_module_id) {
        this.setCourseModuleTabActive(courseClass.course_module_id)
      }

      clearInterval(this.interval)
      this.$emit('ended')
    },

    ended() {
      clearInterval(this.interval)     
      this.$emit('ended')
    },  
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  background-color: #3a3a3a;
}

.up-next-label {
  margin: 0;
  margin-top: -5px;
  margin-bottom: 8px;
  font-weight: 600;
  color: #fff;
  font-size: 18px;

  @media (max-width: 550px) { display: none }
}

.countdown-label {
  color: darken(#fff, 30);
  margin-bottom: 8px;
}

.container-previous-next {
  position: relative;
  padding: 0 calc(65.75px);

  .img-next {
    border-radius: 8px;
    max-width: 400px;
    width: 100%;
  }
}

.btn-previous {
  left: -32px;
  transform: translate(100%, -50%);
}

.btn-next {
  right: -32px;
  transform: translate(-100%, -50%);
}

@media (max-width: 550px) {
  .btn-previous { left: -16px }

  .btn-next { right: -16px }
}

.btn-action {
  position: absolute;
  opacity: 1;
  background: linear-gradient(90deg, #ff7300 -3.33%, #ff5c00 100%);
  box-shadow: 0px 2.5rem4px rgba(0, 0, 0, 0.25), 5px 5px 30px rgba(0, 0, 0, 0.2);
  border-radius: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  top: 50%;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 100%;

  svg {
    fill: #fff;
    width: 50%;
  }

  &[disabled] {
    display: none;
  }
}

.cancel {
  cursor: pointer;
  margin-top: 8px;
  text-align: center;
  color: #939393;
}
</style>
